export default "__VITE_ASSET__BL9qBsm4__"